<template>
    <div ref="top">
        <div class="mb-5">
            <h3 class="text-danger">Thank You For Your Order!</h3>
            <p>Pending item availability, orders will be fulfilled and shipped out within 10 business days.</p>
        </div>
        <div class="mb-3">
            <h4>Contact Information</h4>
            <ul class="list-unstyled">
                <li>First Name: {{ order.first_name }}</li>
                <li>Last Name: {{ order.last_name }}</li>
                <li>Phone Number: {{ order.phone }}</li>
                <li>Email Address: {{ order.email }}</li>
                <li>Employee Type: {{ employeeTypes[order.employee_type] }}</li>
                <li>Location ID: {{ order.location_id }}</li>
                <li>Location Address: {{ order.location_address }}</li>
                <li>Location City: {{ order.location_city }}</li>
                <li>Location State: {{ order.location_state }}</li>
                <li>Location Zip: {{ order.location_zip }}</li>
                <li>Message: {{ order.message }}</li>
            </ul>
        </div>
        <div v-if="order.products" class="mb-3">
            <h4>Premium Items Requested</h4>
            <ul class="list-unstyled">
                <li v-for="product in order.products">{{ product.name }}: {{ product.pivot.quantity }}</li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        order: {
            type: Object,
            required: true
        },
        employeeTypes: {
            type: Object,
            default() {
                return {};
            }
        },
    },
    mounted() {
        const el = this.$refs.top;

        if (el) {
            el.scrollIntoView({behavior: 'smooth'});
        }
    }
}
</script>
